<template>
    <div class="rawText" v-html="content" v-if="$props.disabled===true"></div>
    <div v-else>
        <trumbowyg v-model="content" :config="config" class="form-control" name="content"></trumbowyg>
    </div>
</template>

<script>
import Trumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload';
import 'trumbowyg/dist/ui/trumbowyg.css';

export default {
    props: [ 'disabled' ],
    components: {
        Trumbowyg
    },
    data: function() {
        return {
            content: this.$attrs.value,
            config: {
                btns: [
                    ['viewHTML'],
                    ['formatting'],
                    ['strong', 'em'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen'],
                    ['btnGrp-image'],
                ],
                btnsDef: {
                    // Create a new dropdown
                        'btnGrp-image': {
                        dropdown: [ 'insertImage', 'upload' ],
                        ico: 'insertImage'
                    },
                },
                semantic: {
                   'div': 'div' // Editor does nothing on div tags now
                },
                plugins: {
                    upload: {
                        serverPath: this.$myServerAddresses.images
                    }
                }
            }
        };
    },
    watch: {
        content: function(){
            this.value = this.content;
            this.$emit('input', this.value);
        }
    },
    methods: {
        update: function()
        {
            this.$forceUpdate();
        }
    }
}
</script>

<style lang="scss">
.trumbowyg-button-pane {
    background-color: #eee;
}
.rawText {
    margin-top: 30px;
    height: 300px;
    overflow-y: scroll;
    color: #afafae;

    img { opacity: .4; }
    a { color: #aaa; }
}
</style>

